import { render, staticRenderFns } from "./reasons-to-buy-in-wasaga-beach.vue?vue&type=template&id=007dab0c&"
import script from "./reasons-to-buy-in-wasaga-beach.vue?vue&type=script&lang=js&"
export * from "./reasons-to-buy-in-wasaga-beach.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports